<template>
  <div v-loading="!dataList">
    <!-- NOTE: 空数据情况: 开发人员根据业务调整 -->
    <template v-if="total == 0 && !isSearch">
      <StdNullPage text="暂无内容" :nullType="'nullData'"></StdNullPage>
    </template>

    <!-- 非空数据情况 -->
    <template v-else>
      <!-- NOTE: 搜索栏: 开发人员根据业务调整  -->
      <StdSearchBar
        v-model="keyword"
        style="overflow: hidden"
        placeholder="搜索标题"
        @search="handleSearch"
      ></StdSearchBar>

      <!-- NOTE: 表格数据: 开发人员根据业务调整  -->
      <vh-table :data="dataList" ref="table" style="width: 100%">
        <template slot="empty">
          <StdNullPage text="暂未搜索到您想要的内容" :nullType="'search'"></StdNullPage>
        </template>

        <vh-table-column label="ID" width="80">
          <template slot-scope="scope">
            {{ scope.row.id }}
          </template>
        </vh-table-column>
        <vh-table-column prop="title" label="标题">
          <template slot-scope="scope">
            <vh-tooltip effect="dark" placement="top-start" :content="scope.row.title">
              <div class="custom-tooltip-content">{{ scope.row.title }}</div>
            </vh-tooltip>
          </template>
        </vh-table-column>
        <vh-table-column prop="award_type" label="类型" width="100">
          <template slot-scope="scope">{{ scope.row.award_type }}</template>
        </vh-table-column>
        <vh-table-column prop="remark" label="其他说明" width="">
          <template slot-scope="scope">
            {{ scope.row.remark || '-' }}
          </template>
        </vh-table-column>
      </vh-table>
      <!-- NOTE: 分页: 开发人员根据业务调整  -->
      <StdPagination
        :total="total || 0"
        :page-size="pagination.limit"
        :currentPage="pagination.pageNo"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </template>
  </div>
</template>

<script>
  import { tableCellTooltip } from '@vhcl/ui-console';
  import { StdNullPage, StdSearchBar, StdPagination } from '@vhcl/ui-console';
  import { getAwardList } from '../common/api';
  export default {
    mixins: [tableCellTooltip],
    components: {
      StdNullPage,
      StdSearchBar,
      StdPagination
    },
    props: {
      redPacketId: {},
      type: {},
      source: {
        default: 'admin' //live:发起端，admin:控制台
      }
    },
    data() {
      return {
        isNoData: false,

        keyword: '',
        multipleSelection: [],
        dataList: '',
        total: 0, // 总数量
        isEmpty: false,
        selectId: '',
        // 分页参数
        pagination: {
          limit: 10,
          pageNo: 1
        },
        isSearch: false
      };
    },
    created() {
      this.fetchData();
    },
    methods: {
      handleSearch() {
        console.log('======ok===');
        this.pagination.pageNo = 1;
        this.fetchData();
      },
      // 翻页事件
      handleCurrentChange(current) {
        this.pagination.pageNo = current; //当前页码
        this.fetchData();
      },
      // 每页条数改变时触发
      handleSizeChange(limit) {
        this.pagination.limit = limit;
        this.pagination.pageNo = 1;
        this.fetchData();
      },
      // 模拟请求数据
      fetchData: async function () {
        // this.loading = true;
        this.keyword = this.keyword.trim();
        const res = await getAwardList({
          keyword: this.keyword,
          pos: (this.pagination.pageNo - 1) * this.pagination.limit,
          limit: this.pagination.limit
        });
        this.isSearch = this.keyword.trim() != '';
        if (res.code == 200) {
          this.dataList = res.data.list;
          this.total = res.data.total;
        }
      },
      exportRcord() {
        exportRcord({
          keyword: this.keyword
        }).then(res => {
          if (res.code == 200) {
            this.$message({
              message: '导出成功，请去下载中心下载',
              type: 'success'
            });
          }
        });
      },
      handleCommand({ cmd, row }) {
        console.log(dataJson);
      }
    }
  };
</script>
